import React, { useEffect, useState } from "react";
import axios from "../api/axiosAuth";

const BoletinProfesor = () => {
  const [asignaciones, setAsignaciones] = useState([]);
  const [asignacion, setAsignacion] = useState(null);
  const [periodos, setPeriodos] = useState([]);
  const [periodoId, setPeriodoId] = useState("");
  const [estudiantes, setEstudiantes] = useState([]);
  const [loading, setLoading] = useState(false);

  /* ===============================
     📌 CARGAR INICIAL
  =============================== */
  useEffect(() => {
    cargarAsignaciones();
    cargarPeriodos();
  }, []);

  const cargarAsignaciones = async () => {
    try {
      const res = await axios.get("/boletin/profesor/asignaciones");
      setAsignaciones(Array.isArray(res.data) ? res.data : res.data?.asignaciones || []);
    } catch (error) {
      console.error("❌ Error asignaciones:", error);
      setAsignaciones([]);
    }
  };

  const cargarPeriodos = async () => {
    try {
      const res = await axios.get("/cronograma/periodos");

      // 🔥 FIX CLAVE: normalización defensiva
      const data =
        res.data?.periodos ||
        res.data?.data ||
        res.data ||
        [];

      setPeriodos(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("❌ Error periodos:", error);
      setPeriodos([]);
    }
  };

  /* ===============================
     📌 CARGAR ESTUDIANTES
  =============================== */
  useEffect(() => {
    if (asignacion && periodoId) {
      cargarEstudiantes();
    }
  }, [asignacion, periodoId]);

  const cargarEstudiantes = async () => {
    try {
      setLoading(true);

      const res = await axios.get("/boletin/profesor/estudiantes", {
        params: {
          grado: asignacion?.grado,
          grupo: asignacion?.grupo,
          periodo_id: periodoId,
        },
      });

      setEstudiantes(res.data?.estudiantes || []);
    } catch (error) {
      console.error("❌ Error estudiantes:", error);
      setEstudiantes([]);
    } finally {
      setLoading(false);
    }
  };

  /* ===============================
     📌 DESCARGAS
  =============================== */
  const descargarBoletin = (estudianteId) => {
    if (!periodoId || !asignacion) return;

    window.open(
      `/api/boletin/profesor/descargar/${estudianteId}?periodo_id=${periodoId}`,
      "_blank"
    );
  };

  const descargarGrupo = () => {
    if (!asignacion || !periodoId) return;

    window.open(
      `/api/boletin/profesor/descargar-grupo?grado=${asignacion.grado}&grupo=${asignacion.grupo}&periodo_id=${periodoId}`,
      "_blank"
    );
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>📄 Boletines del Profesor</h2>

      {/* ================= FILTROS ================= */}
      <div style={{ display: "flex", gap: 10, marginBottom: 15 }}>

        {/* ASIGNACIONES */}
        <select
          value={asignacion?.id || ""}
          onChange={(e) => {
            const a = asignaciones.find(
              (x) => String(x.id) === e.target.value
            );
            setAsignacion(a || null);
            setEstudiantes([]);
          }}
        >
          <option value="">Seleccione asignación</option>

          {asignaciones.map((a) => (
            <option key={a.id} value={a.id}>
              {a.materia} - {a.grado} {a.grupo}
            </option>
          ))}
        </select>

        {/* PERIODOS */}
        <select
          value={periodoId}
          onChange={(e) => setPeriodoId(e.target.value)}
          disabled={!asignacion}
        >
          <option value="">Seleccione periodo</option>

          {periodos.map((p) => (
            <option key={p.id} value={p.id}>
              Periodo {p.numero}
            </option>
          ))}
        </select>

        {/* DESCARGAR GRUPO */}
        <button onClick={descargarGrupo} disabled={!asignacion || !periodoId}>
          📦 Descargar grupo
        </button>
      </div>

      {/* ================= TABLA ================= */}
      {loading ? (
        <p>Cargando estudiantes...</p>
      ) : (
        <table border="1" width="100%" cellPadding="8">
          <thead>
            <tr>
              <th>Estudiante</th>
              <th>Acción</th>
            </tr>
          </thead>

          <tbody>
            {estudiantes.length === 0 ? (
              <tr>
                <td colSpan="2">No hay estudiantes</td>
              </tr>
            ) : (
              estudiantes.map((e) => (
                <tr key={e.estudiante_id}>
                  <td>{e.nombres} {e.apellidos}</td>

                  <td>
                    <button onClick={() => descargarBoletin(e.estudiante_id)}>
                      📄 Ver boletín
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default BoletinProfesor;
